import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface WidgetModalOpen {
    isOpen: boolean;
    url: string;
}
const initialState: WidgetModalOpen = {
    isOpen: false,
    url: '',
};
const WidgetModalOpenSlice = createSlice({
    name: 'WidgetModalpen',
    initialState,
    reducers: {
        setWidgetModalOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
        setWidgetModalUrl: (state, action: PayloadAction<string>) => {
            state.url = action.payload;
        },
    },
});

export const { setWidgetModalOpen, setWidgetModalUrl } =
    WidgetModalOpenSlice.actions;
export default WidgetModalOpenSlice.reducer;
